function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 8.86c-.39 0-.7-.31-.7-.7V6.88a3.482 3.482 0 00-3.83-3.47c-1.68.16-3.15 1.87-3.15 3.65v.9c0 .39-.31.7-.7.7-.39 0-.7-.31-.7-.7v-.9c0-2.5 2.02-4.81 4.41-5.04 1.39-.13 2.73.31 3.76 1.25 1.02.92 1.6 2.24 1.6 3.61v1.28c0 .39-.31.7-.69.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.96 8.96c-.84-.93-2.22-1.38-4.24-1.38H8.28c-2.02 0-3.4.45-4.24 1.38-.97 1.08-.94 2.52-.83 3.52l.7 5.57C4.12 20 4.91 22 9.21 22h5.58c4.3 0 5.09-2 5.3-3.94l.7-5.59c.11-.99.14-2.43-.83-3.51zM12 18.58c-2.09 0-3.79-1.7-3.79-3.79S9.91 11 12 11s3.79 1.7 3.79 3.79-1.7 3.79-3.79 3.79z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 18.58A3.79 3.79 0 1012 11a3.79 3.79 0 000 7.58z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6 15.31l-.53-.53.5-.5c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-.5.5-.53-.53a.754.754 0 00-1.06 0c-.29.29-.29.77 0 1.06l.53.53-.55.55c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l.55-.55.53.53c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.76 0-1.06z"
})));